import BaiduMap from 'vue-baidu-map'
import Vue from 'vue'
Vue.use(BaiduMap, {
  ak: 'gVako2Nm7CtU0EO7YivNmjpmW6wnSMWX'
})
